"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operator = void 0;
/**
 * @enum Operator
 * @description Provides values for filter operator.
 * @member and to combine multiple filters with an and.
 * @member or to combine multiple filters with an or.
 * @member not to add filter witch has to be not matched.
 * @member eq to add `equality` condition to filter.
 * @member ne to add `not equal` condition to filter.
 * @member lt to add `les than` condition to filter.
 * @member lte to add `tess than or equal` condition to filter.
 * @member gt to add `greater than` condition to filter.
 * @member gte to add `greater than or equal` condition to filter.
 * @member hasSome to add `has some values of provided` condition to filter.
 * @member hasAll to add `has all values of provided` condition to filter.
 * @member contains to add `field value contains provided value` condition to filter.
 * @member startsWith to add `field value starts with provided value` condition to filter.
 * @member endsWith to add `ends with provided value` condition to filter.
 * @member urlized to add `urlized provided value` condition to filter.
 */
var Operator;
(function (Operator) {
    Operator["and"] = "$and";
    Operator["or"] = "$or";
    Operator["not"] = "$not";
    Operator["eq"] = "$eq";
    Operator["ne"] = "$ne";
    Operator["lt"] = "$lt";
    Operator["lte"] = "$lte";
    Operator["gt"] = "$gt";
    Operator["gte"] = "$gte";
    Operator["hasSome"] = "$hasSome";
    Operator["hasAll"] = "$hasAll";
    Operator["contains"] = "$contains";
    Operator["startsWith"] = "$startsWith";
    Operator["endsWith"] = "$endsWith";
    Operator["urlized"] = "$urlized";
})(Operator = exports.Operator || (exports.Operator = {}));
//# sourceMappingURL=filter.js.map